"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var trendingModels_1 = __importDefault(require("./trendingModels"));
var DefaultSuggestions_styles_1 = require("../DefaultSuggestions.styles");
function DefaultRecommended(_a) {
    var handleDefaultSuggestionClicked = _a.handleDefaultSuggestionClicked, inModal = _a.inModal;
    return (react_1.default.createElement(DefaultSuggestions_styles_1.SuggestionSectionContainer, null,
        react_1.default.createElement(DefaultSuggestions_styles_1.SectionTitle, { className: inModal ? 'pl-16' : '' }, "Trending models"),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('flex gap-8', inModal ? DefaultSuggestions_styles_1.modalStyles : 'flex-wrap') }, trendingModels_1.default.map(function (model) { return (react_1.default.createElement(DefaultSuggestions_styles_1.SuggestionLinkWrapper, { "data-analytics-id": "Default Suggestions", "data-analytics-attributes": JSON.stringify({
                category: 'Trending Models',
                label: model.text
            }), "data-qa": "Default Search Trending", defaultSuggestion: model, handleDefaultSuggestionClicked: handleDefaultSuggestionClicked, key: model.text },
            react_1.default.createElement(DefaultSuggestions_styles_1.SuggestionLinkText, null, model.text))); }))));
}
exports.default = DefaultRecommended;
//# sourceMappingURL=DefaultTrending.js.map